import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
const styles = theme => ({
    button: {
      margin: theme.spacing.unit,
    },
    input: {
      display: 'none',
    },
  });
class SectionHowItWorks extends Component {
    render() {
        return (
            <section className="how_it_works">
                <div className="content">
                    <div className="section_left">
                        <a>HOW IT WORKS</a>
                    </div>
                    <div className="section_right">
                        <h3>Kbaaz platform move <br/> party donation to your savings</h3>
                        <div className="steps">
                            <div className="single_step">
                                <div className="step_number"><span>1</span></div>
                                <div className="step_image">
                                    <img src={require('../../assets/images/how1.png')} />
                                </div>
                                <div className="step_title">
                                    Host an event
                                </div>
                            </div>
                            <div className="single_step">
                                <div className="step_number"><span>2</span></div>
                                <div className="step_image">
                                    <img src={require('../../assets/images/how2.png')} />
                                </div>
                                <div className="step_title">
                                    We send invites to collect money
                                </div>
                            </div>
                            <div className="single_step">
                                <div className="step_number"><span>3</span></div>
                                <div className="step_image">
                                    <img src={require('../../assets/images/how3.png')} />
                                </div>
                                <div className="step_title">
                                    People send money instead of gifts
                                </div>
                            </div>
                            <div className="single_step">
                                <div className="step_number"><span>4</span></div>
                                <div className="step_image">
                                    <img src={require('../../assets/images/how4.png')} />
                                </div>
                                <div className="step_title">
                                    We put money into your account
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}
SectionHowItWorks.propTypes = {
    classes: PropTypes.object.isRequired,
  };
export default withStyles(styles)(SectionHowItWorks);


// WEBPACK FOOTER //
// ./src/components/Landing/SectionHowItWorks.js